import { Component, Input } from '@angular/core';
import { VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { formatEngineOnDuration } from './kpis.utils';

@Component({
  selector: 'app-voltage-speed-kpis',
  templateUrl: './kpis.component.html',
  styleUrls: ['./kpis.component.css'],
})
export class VoltageSpeedKpisComponent {
  @Input() summary: VoltageSpeedDashboardSummary | null = null;
  @Input() loading = false;

  get engineOnDuration(): string {
    return formatEngineOnDuration(this.summary?.EngineOnSeconds);
  }
}
